import React, { useContext } from "react";
import "./VendorDetails.css";
import { Button, Modal } from "react-bootstrap";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import { Context } from "../../../utils/context";

function VendorDetails(props) {
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { IMG_URL } = useContext(Context);

  const [previewImage, setPreviewImage] = React.useState(null);
  const [showImageModal, setShowImageModal] = React.useState(false);

  const handleImageClick = (img) => {
    setPreviewImage(img);
    setShowImageModal(true);
  };

  const handleCloseImageModal = () => {
    setShowImageModal(false);
    setPreviewImage(null);
  };

  return (
    <>
      <div className="Successfull_Modal_sec">
        <Modal
          className="Successfull_Modal VendorDetails_Modal"
          {...props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>Vendor Details</Modal.Header>
          <Modal.Body>
            <div className="lottie-holder">
              {/* {props?.details?.id} */}

              <div className="tabs_holder">
                <TabContext value={value} className="main-tab">
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                      className="main-tab"
                    >
                      <Tab label="User Details" value="1" />
                      <Tab label="Store Details" value="2" />
                      <Tab label="Document Details" value="3" />
                      <Tab label="Categories" value="4" />
                    </TabList>
                  </Box>
                  <TabPanel value="1">
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">City:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {props?.details?.users_detail?.city?.name || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Pincode:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail?.pincode?.name ||
                                "-"}
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Area:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail?.area || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Owner Contact:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.contact_no || "-"}
                            </p>
                          </div>
                        </div>

                        {/* <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Watsapp Number:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail?.watsapp_no || "-"}
                            </p>
                          </div>
                        </div> */}

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">LOGO:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {props?.details?.logo ? (
                                <img
                                  src={IMG_URL + props?.details?.logo}
                                  alt="Logo"
                                  style={{ maxWidth: "100px", height: "auto" }}
                                  onClick={() =>
                                    handleImageClick(
                                      IMG_URL + props?.details?.logo,
                                    )
                                  }
                                />
                              ) : (
                                "No Image"
                              )}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Registration Number:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail?.registration_no ||
                                "-"}
                            </p>
                          </div>
                        </div>
                      </div>{" "}
                      <div className="col">
                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Name of Certificate:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail
                                ?.name_of_certificate || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Licence Number:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail?.licence_no || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Licence Exp Date:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail?.licence_exp_date ||
                                "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Licence Type:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail?.licence_type ||
                                "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Licence Name:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail?.name_in_licence ||
                                "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Address in Licence:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.users_detail
                                ?.address_in_licence || "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel value="2">
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Store Name:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {props?.details?.store_detail?.store_name || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Name Of Owner:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.first_name || "-"}
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Owner Email:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.email || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Owner Contact no:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.contact_no || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Role In Store:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.role_in_store || "-"}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col">
                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Lat:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {props?.details?.store_detail?.lat || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Long:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.store_detail?.long || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Store Address:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.store_detail?.store_address ||
                                "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">City:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.store_detail?.city?.name || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Pincode:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.store_detail?.pincode?.name ||
                                "-"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel value="3">
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Pan No:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {props?.details?.document?.pan_no || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Pan Image:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {props?.details?.document?.pan_image ? (
                                <img
                                  src={
                                    IMG_URL +
                                    props?.details?.document?.pan_image
                                  }
                                  alt="Logo"
                                  style={{ maxWidth: "100px", height: "auto" }}
                                  onClick={() =>
                                    handleImageClick(
                                      IMG_URL +
                                        props?.details?.document?.pan_image,
                                    )
                                  }
                                />
                              ) : (
                                "No Image"
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">GST No:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.document?.gst_no || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">GST Image:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {props?.details?.document?.gst_image ? (
                                <img
                                  src={
                                    IMG_URL +
                                    props?.details?.document?.gst_image
                                  }
                                  alt="Logo"
                                  style={{ maxWidth: "100px", height: "auto" }}
                                  onClick={() =>
                                    handleImageClick(
                                      IMG_URL + props?.details?.image,
                                    )
                                  }
                                />
                              ) : (
                                "No Image"
                              )}
                            </p>
                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Passbook Image:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              <img
                                src={
                                  IMG_URL +
                                  props?.details?.bank_detail?.passbook
                                }
                                alt="Logo"
                                style={{ maxWidth: "100px", height: "auto" }}
                                onClick={() =>
                                  handleImageClick(
                                    IMG_URL + props?.details?.image,
                                  )
                                }
                              />
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">KYC Image:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              <img
                                src={IMG_URL + props?.details?.bank_detail?.kyc}
                                alt="Logo"
                                style={{ maxWidth: "100px", height: "auto" }}
                                onClick={() =>
                                  handleImageClick(
                                    IMG_URL + props?.details?.image,
                                  )
                                }
                              />
                            </p>
                          </div>
                        </div> */}
                      </div>

                      <div className="col">
                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Account No:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {props?.details?.bank_detail?.acc_no || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Beneficiary Name:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.bank_detail?.beneficiary_name ||
                                "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Bank Name:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.bank_detail?.bank_name || "-"}
                            </p>
                          </div>
                        </div>

                        {/* <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Bank Branch:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.bank_detail?.branch_name || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Bank City:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.bank_detail?.city || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-4">
                            <p className="label_text">Bank Pincode:</p>
                          </div>
                          <div className="col-lg-8">
                            <p className="value_text">
                              {" "}
                              {props?.details?.bank_detail?.pincode || "-"}
                            </p>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel value="4">
                    <div className="row">
                      <div className="col">
                        <h5>Category</h5>
                        {props?.details?.vendor_selected_categories?.map(
                          (v) => (
                            <div className="row">
                              <div className="col-lg-8">
                                <p className="value_text">
                                  {"->"} {v?.vendor_category?.name}
                                </p>
                              </div>
                            </div>
                          ),
                        )}
                      </div>

                      <div className="col">
                        <h5>Sub Category</h5>
                        {props?.details?.vendor_selected_subcategories?.map(
                          (v) => (
                            <div className="row">
                              <div className="col-lg-8">
                                <p className="value_text">
                                  {"->"} {v?.vendor_sub_category?.name}
                                </p>
                              </div>
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  </TabPanel>
                </TabContext>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={showImageModal}
          onHide={handleCloseImageModal}
          centered
          size="xl"
          className="ImagePreviewModal"
        >
          {/*Top Right Close Button */}
          <Modal.Header closeButton />
          <Modal.Body className="text-center">
            {previewImage && (
              <img
                src={previewImage}
                alt="Preview"
                className="full_preview_img"
              />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default VendorDetails;
